import React, { useEffect, useState } from 'react';
import moment from 'moment';
import Api from '../../../services/Api';
import ReactiveTable from '../../Organisms/ReactiveTable/ReactiveTable';

const CharacteristicsPage = () => {
  const [characteristics, setCharacteristics] = useState([]);
  const refreshFields = () => {
    Api.get('types/characteristics?per_page=200').then((response) => {
      if (response.status === 200) {
        const mappedValues = response.data.data.map(char => ({
          label: `${char.name} [${char.code}]`,
          value: char.id,
        }));
        setCharacteristics(mappedValues);
      }
    });
  };

  useEffect(() => {
    refreshFields();
  }, []);
  const columns = [
    {
      name: 'Code',
      selector: row => row.code,
      sortable: true,
    },
    {
      name: 'Characteristic',
      selector: row => row.name,
      sortable: true,
    },
    {
      name: 'Parent',
      selector: (row) => {
        if (row.parent) {
          return row.parent.name;
        }
        return '-';
      },
      sortable: true,
    },
    {
      name: 'Created',
      selector: row => moment(row.created_at).fromNow(),
      sortable: true,
    },
    {
      name: 'Updated',
      selector: row => moment(row.updated_at).fromNow(),
      sortable: true,
    },
  ];
  const fields = [
    'name',
    'code',
    {
      key: 'parent_id',
      type: 'select',
      options: characteristics,
    },
  ];
  return (
    <>
      <div className="col-md-12 header-container">
        <h2>Characteristics</h2>
      </div>
      <div className="col-md-12 content-container">
        <ReactiveTable
          columns={columns}
          endpoint="types/characteristics"
          exportableKeys={['id', 'name', 'code', 'parent_id']}
          modalTitle="Characteristic"
          fields={fields}
          onFetching={() => refreshFields()}
        />
      </div>
    </>
  );
};

export default CharacteristicsPage;
